'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _helpers = require('./_helpers');

var _utils = require('../utils');

var _swiperEsm = require('swiper/dist/js/swiper.esm.js');

/* prettier-ignore */
function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var swiperContainer = context.getElement('.' + context.className + '_Carousel');

  var carousel = void 0;

  makeCarousel();

  window.addEventListener('resize', makeCarousel);

  function makeCarousel() {
    if (window.innerWidth >= _utils.mediaBreakpoints.md && carousel !== undefined) {
      carousel.destroy();
      carousel = undefined;
    } else if (window.innerWidth < _utils.mediaBreakpoints.md && carousel === undefined) {
      carousel = (0, _helpers.initialiseSwiper)(swiperContainer, {
        loop: false,
        watchSlidesProgress: true,
        slidesPerView: 1,
        spaceBetween: 20,
        speed: 500,
        slideClass: context.className + '_Slide',
        navigation: {
          nextEl: '.' + context.className + '_Next',
          prevEl: '.' + context.className + '_Prev',
          disabledClass: 'sec-Usps_Control-hidden'
        }
      }, [_swiperEsm.Navigation]);
    }
  }
}